var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgUnderline = function SvgUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 3,
    viewBox: "0 0 50 3",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.144.58C33.176-.596 17.207.27 1.24.954c-1.652.062-1.652 2.108 0 2.046 15.968-.744 31.937-1.116 47.905-.992 1.18 0 1.102-1.364 0-1.426z",
    fill: "#E469D1"
  })));
};

export default SvgUnderline;